import { useState } from "react";
import MDButton from "components/MDButton";
import { usePermissionMonitor } from "components/PermissionMonitor";
import { useLanguage } from "contexts/language.context";
import GenerateNcrDialog from "layouts/ncr/components/GenerateNcrDialog";
import ncrService from "services/ncr-service";

export default function AuditNcrAction({ audit }) {
  const [open, setOpen] = useState(false);
  const permitted = usePermissionMonitor();
  const { label } = useLanguage();
  if (Number(audit?.statusId) !== 4 || permitted("create", "ncr") !== true)
    return null;
  return (
    <>
      <MDButton variant="outlined" color="info" onClick={() => setOpen(true)}>
        {label("generate-ncr-button") || "Generate NCR"}
      </MDButton>
      {open && (
        <GenerateNcrDialog
          isOpen={open}
          sourceAuditId={audit.id}
          onClose={() => setOpen(false)}
          onSubmit={async (payload) => {
            const [response, data] = await ncrService.createManyNcrs(payload);
            return response.ok
              ? { success: true }
              : { error: data?.error || "Unable to create NCR" };
          }}
        />
      )}
    </>
  );
}
